export const TitleInformationComponent = ({ title }) => {
  return <div className="titleInformationComponent">{title}</div>;
};
